import { render, staticRenderFns } from "./TurningOn.vue?vue&type=template&id=c676e8ea"
import script from "./TurningOn.vue?vue&type=script&lang=ts"
export * from "./TurningOn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports